"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./_styles.scss");
var _reactComponents = require("@ui-propulsion/react-components");
var _util = require("../../../util");
var _details = _interopRequireDefault(require("./details"));
var BLOCK_CLASS = 'pf-income-details-accordion';
var IncomeDetails = function IncomeDetails(_ref) {
  var className = _ref.className,
    details = _ref.details,
    header = _ref.header;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: (0, _util.addClassNames)(className, BLOCK_CLASS)
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.App, null, /*#__PURE__*/_react.default.createElement(_reactComponents.Accordion, {
    data: [{
      id: 'accordion-wrapper',
      header: /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(BLOCK_CLASS, "__header")
      }, header),
      details: /*#__PURE__*/_react.default.createElement(_details.default, {
        details: details
      })
    }]
  })));
};
IncomeDetails.propTypes = {
  className: _propTypes.default.string,
  header: _propTypes.default.string,
  details: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.string,
    title: _propTypes.default.string,
    text: _propTypes.default.arrayOf(_propTypes.default.string)
  }))
};
IncomeDetails.defaultProps = {
  className: 'default-class-name',
  header: 'What can I include as total annual income?',
  details: [{
    text: ['Some examples of income include the following:']
  }, {
    icon: 'checkmark-income',
    title: 'Income from employment,',
    text: [' including full-time, part-time, freelance, or seasonal jobs']
  }, {
    icon: 'checkmark-income',
    title: 'Self-employment,',
    text: [' including any business dividends or rental income']
  }, {
    icon: 'checkmark-income',
    title: 'Non-taxable-income,',
    text: [' if included, should be increased by 25%']
  }, {
    icon: 'checkmark-income',
    title: 'Any other income such as retirement, ',
    text: [' social security, or public assistance', 'Only include alimony, child support, or separate maintenance if you wish for us to consider it as a source of loan repayment.']
  }]
};
var _default = IncomeDetails;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');